var exports = {
  "P": "xe533113f--bc967e--label",
};

module.exports = exports;
